const prod = {
  stripe: {
    apiKey: 'pk_live_Wi9AWeRvtAq4BlfsbXEPYQux0064q5Nt5J',
    createCustomerUrl: 'https://o60lf20384.execute-api.eu-west-2.amazonaws.com/prod/customers',
    setupIntentUrl: 'https://o60lf20384.execute-api.eu-west-2.amazonaws.com/prod/setupintents',
  },
};

const test = {
  stripe: {
    apiKey: 'pk_test_immpjEfj5u62CBZVHdK2C96S00th60XICM',
    createCustomerUrl: 'https://iwnmqk9wg8.execute-api.eu-west-2.amazonaws.com/test/customers',
    setupIntentUrl: 'https://iwnmqk9wg8.execute-api.eu-west-2.amazonaws.com/test/setupintents',
  },
};

const dev = {
  stripe: {
    apiKey: 'pk_test_UJDGH2xzd3Orla2lMrpd1xWK',
    createCustomerUrl: 'https://soejuwxx1c.execute-api.eu-west-2.amazonaws.com/dev/customers',
    setupIntentUrl: 'https://soejuwxx1c.execute-api.eu-west-2.amazonaws.com/dev/setupintents',
  },
};

let config;
switch (process.env.REACT_APP_STAGE) {
  case 'prod': {
    config = prod;
    break;
  }
  case 'test': {
    config = test;
    break;
  }
  default: {
    config = dev;
    break;
  }
}

export default {
  currency: 'GBP',
  ...config
}
